import UcConnection from "@/components/atoms/Icon/ucConnection";
import { NextImage } from "@/components/atoms/NextImage";
import { useAuthUser } from "@/hooks/common/useAuthUser";

const UcConnectApp = () => {
  const { workspaceConfig } = useAuthUser();

  return (
    <div className="relative w-1/4 h-0.5 flex justify-center border-b border-dashed border-primary-selected dark:border-primary">
      <div className="w-14 h-14 px-2 bg-background absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent">
          <div className="animate-bounce ">
            {workspaceConfig?.isCore ? (
              <UcConnection />
            ) : (
              <NextImage
                src={
                  workspaceConfig?.faviconUrl || "/assets/images/png/usite.png"
                }
                width={20}
                height={20}
                alt="logo"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UcConnectApp;
